<template>
  <div>
    <v-container class="container px-0">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.users") }}
          </h4>
        </v-col>

        <v-col
          class="page-title__filter-controls justify-end align-end"
          :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
        >
          <DataIteratorFilterControls
            :showSearchTerm="true"
            :searchTerm="searchTerm"
            :fullWidthSearch="false"
            :fullWidthLg="false"
            :fullWidthMd="true"
            @update:searchTerm="searchTerm = $event"
            :class="'my-hostings-search'"
          ></DataIteratorFilterControls>

          <!-- <v-btn
            :large="!$vuetify.breakpoint.smAndDown"
            elevation="0"
            color="primary"
            class="p-2 add-new-button page-title__add-button"
          >
            <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
              >$plus
            </v-icon>
            {{ $vuetify.breakpoint.mobile ? "" : $t("button.domain.add") }}
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0">
      <v-row>
        <v-col cols="12">
          <v-card elevation="4" class="data-table">
            <v-data-table
              :loading="fetchingUsers"
              :headers="headers"
              :items="users"
              :search="searchTerm"
              item-key="id"
              must-sort
              calculate-widths
              disable-pagination
              hide-default-header
              hide-default-footer
              class="elevation-0 custom-data-table"
              :options.sync="options"
            >
              <template v-slot:no-data>
                <data-iterator-no-results-container
                  v-if="searchTerm"
                  @clearAllFilters="clearFilters()"
                  :searchTerm="searchTerm"
                />
                <div v-else class="no-data-container">
                  <no-data-table-user class="mb-6"/>
                  <h6 class="no-data-container__title mb-4 font-weight-bold">{{ $t('reseller.logs.noLogs') }}</h6>
                  <p class="no-data-container__description mb-0">{{ $t('reseller.logs.noLogsDesc') }}</p>
                </div>
              </template>
              <template v-slot:no-results>
                <data-iterator-no-results-container
                  @clearAllFilters="clearFilters()"
                  :searchTerm="searchTerm"
                />
              </template>
              <template v-if="fetchingUsers" v-slot:body>
                <template v-if="$vuetify.breakpoint.lgAndDown">
                  <logs-table-item-skeleton-mobile
                    v-for="item in 5"
                    :key="item"
                  />
                </template>
                <template v-else>
                  <logs-table-skeleton-item />
                </template>
              </template>
              <template
                v-if="!$vuetify.breakpoint.mobile && users.length"
                v-slot:header="{ props }"
              >
                <tr class="custom-sort">
                  <td
                    v-for="header in props.headers"
                    :key="header.value"
                    class="sort-item"
                    @click="header.sortable && toggleSort(header)"
                  >
                    <div
                      class="custom-sort__item"
                      :class="{
                        'custom-sort__item--sortable': header.sortable,
                      }"
                    >
                      {{ header.text !== 'actions' ? $t(`table.header.${header.text}`) : '' }}
                      <div class="custom-sort__arrows" v-if="header.sortable">
                        <v-icon
                          size="12"
                          class="custom-sort__arrow-up"
                          :up="
                            !props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                          :down="
                            props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                        >
                          $arrowsSort
                        </v-icon>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template
                v-if="$vuetify.breakpoint.mobile"
                v-slot:item="{ item, headers }"
              >
                <tr>
                  <td class="w-100">
                    <div class="mobile-table-item">
                      <div class="mobile-table-item__values">
                        <div
                          class="mobile-table-item__row"
                          v-for="header in headers"
                          :key="header.value"
                        >
                          <div class="mobile-table-item__header">
                            {{ $t(`table.header.${header.text}`) }}
                          </div>
                          <div class="mobile-table-item__value">
                            <UsersTableCell
                              :item="item"
                              :header="header"
                              isMobile
                              @action-button-delete="
                                $refs.UserDeleteModal.open($event)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else v-slot:item="{ item, headers }">
                <tr>
                  <td v-for="(header, index) in headers" :key="header.value" class="text-start" :class="{ 'font-weight-bold': index === 0 }">
                    <UsersTableCell
                      :item="item"
                      :header="header"
                      @action-button-delete="$refs.UserDeleteModal.open($event)"
                    />
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <UserDeleteModal
                  ref="UserDeleteModal"
                  v-on="$listeners"
                  @user-deleted="userDeleted"
                />
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "../../apis/Api";
import UserDeleteModal from "./UserDeleteModal.vue";
import UsersTableCell from "./UsersTableCell.vue";
import LogsTableItemSkeletonMobile from "../../components/dataIterator/tables/LogsTableItemSkeletonMobile.vue";
import LogsTableSkeletonItem from "../../components/dataIterator/tables/LogsTableSkeletonItem.vue";
import DataIteratorFilterControls from "../../components/dataIterator/DataIteratorFilterControls.vue";
import DataIteratorNoResultsContainer from "../../components/dataIterator/DataIteratorNoResultsContainer.vue";
import NoDataTableUser from "../../components/icons/noDataTableUsers.vue";
export default {
  components: {
    UserDeleteModal,
    UsersTableCell,
    LogsTableItemSkeletonMobile,
    LogsTableSkeletonItem,
    DataIteratorFilterControls,
    DataIteratorNoResultsContainer,
    NoDataTableUser,
  },
  props: {},
  data() {
    return {
      fetchingUsers: false,
      users: [],
      options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ["name"],
        sortDesc: [false],
      },
      searchTerm: "",
      headers: [
        {
          text: "user",
          value: "name",
          sortable: true,
        },
        {
          text: "email",
          value: "email",
          sortable: true,
        },
        {
          text: "instances",
          value: "instances_count",
          sortable: true,
        },
        {
          text: "actions",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.fetchingUsers = true;
      Api.get("/reseller/users")
        .then((response) => {
          this.users = response.data.data;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetchingUsers = false;
        });
    },
    toggleSort(header) {
      if (this.options.sortBy[0] === header.value) {
        this.options.sortDesc = [!this.options.sortDesc[0]];
        return;
      }
      this.options.sortBy = [header.value];
    },
    userDeleted(user) {
      this.users = this.users.filter((u) => u.id !== user.id);
    },
    clearFilters() {
      this.searchTerm = "";
    },
  },
  watch: {},
  computed: {},
};
</script>
<style src="../../components/dataIterator/TableCustomSort.scss" lang="scss" scoped />
